import React, { memo } from 'react';
import { createUseStyles } from 'hoi-poi-ui';
import styles from "./styles";
const useStyles = createUseStyles(styles, 'SectionList');
const AttrFormatter = _ref => {
  var _colDef$cellRendererP;
  let {
    value,
    colDef
  } = _ref;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("span", {
    className: classes.attrFormatter
  }, value ? value === null || value === void 0 ? void 0 : value[colDef === null || colDef === void 0 ? void 0 : (_colDef$cellRendererP = colDef.cellRendererParams) === null || _colDef$cellRendererP === void 0 ? void 0 : _colDef$cellRendererP.attr] : '');
};
export default /*#__PURE__*/memo(AttrFormatter);